import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullwidthComponent } from './fullwidth.component';
import { LoginComponent } from 'src/app/modules/login/login.component';
import { RegisterComponent } from 'src/app/modules/register/register.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { AngularFireAuthModule } from "@angular/fire/auth";

import { ReactiveFormsModule } from '@angular/forms';
import { from } from 'rxjs';
import { VerifyEmailComponent } from 'src/app/modules/verify-email/verify-email.component';
import { FbRegisterComponent } from 'src/app/modules/fb-register/fb-register.component';
import { ForgotPasswordComponent } from 'src/app/modules/forgot-password/forgot-password.component';
import { UpdatePhotoComponent } from 'src/app/modules/update-photo/update-photo.component';

@NgModule({
  declarations: [
    FullwidthComponent,
    LoginComponent,
    RegisterComponent,
    VerifyEmailComponent,
    FbRegisterComponent,
    ForgotPasswordComponent,
    UpdatePhotoComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    AngularFireAuthModule,
  ]
})
export class FullwidthModule { }
